import { aboutInfo } from '@/mocks/homeData';

export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1024px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block text-xs font-medium text-accent-600 bg-accent-100/70 px-3 py-1 rounded-full mb-4">
              关于我们
            </span>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-4">{aboutInfo.title}</h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">{aboutInfo.content}</p>

            <div className="grid grid-cols-3 gap-4 md:gap-6">
              {aboutInfo.stats.map((stat) => (
                <div key={stat.label} className="text-center p-4 rounded-xl bg-background-100 border border-background-200/70">
                  <div className="text-xl md:text-2xl font-bold text-primary-500 mb-1">{stat.number}</div>
                  <div className="text-xs text-foreground-500">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>

          <div className="flex-1 w-full max-w-[420px]">
            <div className="relative w-full aspect-square rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=A%20warm%20and%20inviting%20editorial%20office%20scene%20with%20modern%20minimalist%20design%20aesthetic%2C%20clean%20workspace%20with%20natural%20light%20and%20soft%20shadows%2C%20abstract%20geometric%20composition%20in%20warm%20terracotta%20and%20cream%20tones%20representing%20news%20editorial%20team%2C%20sophisticated%20magazine%20style%20photography%20with%20textured%20elements%20and%20balanced%20composition&width=800&height=800&seq=about-brand-visual&orientation=squarish"
                alt="黑料吃瓜品牌介绍 - 编辑团队工作场景"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}